// ABOUTME: Maps each entity type to its smart form wrapper so the detail page renders one component.
// ABOUTME: Add an entry here when a new entity form is introduced — no per-entity branching on the page.
import type {ComponentType} from 'react'

import {EntityType} from '../types'
import {DeliveryWindowEntityForm} from './DeliveryWindowEntityForm'
import {OperationalHoursEntityForm} from './OperationalHoursEntityForm'
import {OrderCancellationLeadTimeEntityForm} from './OrderCancellationLeadTimeEntityForm'
import {OrderIntakeLeadTimeEntityForm} from './OrderIntakeLeadTimeEntityForm'
import {OrderChangeLeadTimeEntityForm} from './OrderChangeLeadTimeEntityForm'
import {QuantityEntityForm} from './QuantityEntityForm'
import {RetarderEntityForm} from './RetarderEntityForm'
import {UnloadingMethodsEntityForm} from './UnloadingMethodsEntityForm'
import {OverbookingAllowanceEntityForm} from './OverbookingAllowanceEntityForm'
import {PumpSettingsEntityForm} from './PumpSettingsEntityForm'
import {TruckSettingsEntityForm} from './TruckSettingsEntityForm'
import {DeliveryRateEntityForm} from './DeliveryRateEntityForm'

export const ENTITY_FORM_REGISTRY: Partial<Record<EntityType, ComponentType>> = {
  quantity: QuantityEntityForm,
  retarder: RetarderEntityForm,
  unloadingMethod: UnloadingMethodsEntityForm,
  deliveryWindow: DeliveryWindowEntityForm,
  operationalHours: OperationalHoursEntityForm,
  orderIntakeLeadTime: OrderIntakeLeadTimeEntityForm,
  orderCancellationLeadTime: OrderCancellationLeadTimeEntityForm,
  orderChangeLeadTime: OrderChangeLeadTimeEntityForm,
  overbookingAllowance: OverbookingAllowanceEntityForm,
  pumpConfiguration: PumpSettingsEntityForm,
  trucks: TruckSettingsEntityForm,
  loadSpacing: DeliveryRateEntityForm,
}
